import React from 'react';
import { Controller, FieldValues, RegisterOptions } from 'react-hook-form';
import { sortBy } from 'lodash';
import useOperatory from 'hooks/useOperatory';
import MultipleSelect, { Option } from '../MultipleSelect/MultipleSelect';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';
import { Props } from 'react-select';

interface IProps {
  control: any;
  name?: string;
  placeholder?: string;
  rules?: Omit<
    RegisterOptions<FieldValues, string>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  onUpdate?: (value: any) => void;
  controlStyles?: React.CSSProperties;
  options?: Option[];
  selectProps?: Props;
}

const OperatoryDropdown = (props: IProps) => {
  const { data: operatories, isLoading } = useOperatory();
  const operatoryOptions = operatories?.map((operatory) => ({
    value: operatory.id,
    label: operatory.name,
    isDisabled: !operatory.status,
  }));

  return (
    <Controller
      {...props}
      name={props.name ?? 'operatories'}
      render={({ field, fieldState }) => {
        const { onChange, value } = field;
        return (
          <>
            <MultipleSelect
              {...props.selectProps}
              isError={!!fieldState.error}
              key={`${isLoading}`}
              isLoading={isLoading}
              placeholder={'Select Chairs'}
              options={sortBy(
                props.options ? props.options : operatoryOptions,
                'label'
              )}
              value={isLoading ? [] : value}
              onChange={(newValue: any) => {
                newValue.forEach((item: any) => delete item.isDisabled);
                onChange(newValue);
                props?.onUpdate?.(newValue);
              }}
              controlStyles={props.controlStyles}
            />
            {fieldState.error && (
              <div className={`flex items-center gap-x-1 mt-0.8`}>
                <WarningIcon />
                <span className="text-12 text-red-01">
                  {fieldState.error.message}
                </span>
              </div>
            )}
          </>
        );
      }}
    />
  );
};

export default OperatoryDropdown;
